/* requires:
polyfill.js
*/

const fmProductPageTool = {
  cartSummaryBaseUrl: 'cart_domain_replaced_during_build/CpsApi/getInfoSummaryData?',
  proctorType: null,
  apiBaseUrl: 'cartAPI_url_replaced_during_build',
  cartUrl: 'cart_domain_replaced_during_build' + '/CartForm',
  globalUpsellCartDataObj: null,
  upsellPrices: {},

  init: () => {
    fmProductPageTool.selectProductType();
  },

  /**
   * Determines the product type and calls the appropriate functions to initialize the product page.
   */
  selectProductType: () => {
    const cartSummaryWrap = document.querySelector('#cart-summary-wrap');
    const productType = cartSummaryWrap.dataset.productType;
    fmProductPageTool.initTrainingCardWrapInfo();
    fmProductPageTool.initAddToCartBtn();
    if (productType !== 'Training') {
      fmProductPageTool.initProctorBtnsAndCheckboxes();
      fmProductPageTool.initAcceptTermsCheckboxes();
      fmProductPageTool.initAcceptContinueBtns();
      fmProductPageTool.initUpsellCheckboxes();
    }
  },

  /**
   * Initializes the training card wrap info.
   * Gets the product data for the training card wrap and renders the card summary for training
   * and non-training products with proctor exams.
   */
  initTrainingCardWrapInfo: () => {
    const summaryWrap = document.querySelector('#cart-summary-wrap');
    const dataSet = summaryWrap.dataset;

    const { productType, productId, categoryProductId, noProctorExam } = dataSet;
    if (productType == 'Training') {
      fmProductPageTool.getCardProductData(productId, categoryProductId);
    } else if (productType != 'Training' && noProctorExam == 'false') {
      fmProductPageTool.getCardProductData(productId, categoryProductId);
    }
  },

  /**
   * Initializes the "Add to Cart" button.
   */
  initAddToCartBtn() {
    document.addEventListener('click', handleClick);

    /**
     * Handles the click event.
     * @param {Event} event - The click event.
     */
    function handleClick(event) {
      const addToCartBtn = event.target.closest('.add-to-cart-btn-fm');
      if (addToCartBtn) {
        event.preventDefault();
        const { mainProductId, mainCategoryProductId } = addToCartBtn.dataset;
        const proctorType = fmProductPageTool.proctorType;
        const upsellData = fmProductPageTool.globalUpsellCartDataObj
          ? JSON.stringify(fmProductPageTool.globalUpsellCartDataObj)
          : null;
        fmProductPageTool.addMainProductAndUpsellToCart(mainProductId, mainCategoryProductId, proctorType, upsellData);
      }
    }
  },

  /**
   * Initializes the proctor buttons and checkboxes.
   * Handles the click event on the proctor buttons and performs various actions such as hiding the cart summary,
   * scrolling to the proctor selection, enabling and disabling buttons, and unselecting upsells and accepted checkboxes.
   */
  initProctorBtnsAndCheckboxes: () => {
    const proctorBtns = document.querySelectorAll('.select-proctor-btn');
    document.addEventListener(
      'click',
      (event) => {
        const eventElement = event.target;
        const proctorBtn = eventElement.closest('.select-proctor-btn');
        if (proctorBtn) {
          // enable all proctor type buttons
          event.preventDefault();
          // hides the cart summary when switching proctor types
          const summaryWrap = document.querySelector('#cart-summary-wrap');
          // hide cart summary
          summaryWrap.classList.add('d-none');
          // set proctor type
          fmProductPageTool.proctorType = proctorBtn.dataset.proctor;
          // scroll user to proctor selection
          const sectionId = proctorBtn.dataset.bsTarget;
          const section = document.querySelector(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
          }
          const testCenterEl = document.querySelector('.test-center');
          if (testCenterEl.classList.contains('d-none')) {
            testCenterEl.classList.remove('d-none');
          }
          // enable all proctor type buttons
          proctorBtns.forEach((btn) => {
            btn.disabled = false;
            btn.innerHTML = 'Select';
          });
          proctorBtn.disabled = true; // disable button
          proctorBtn.innerHTML = 'Selected'; // change button text

          // added to unselect the upsells in summary
          const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');
          upsellCheckboxes.forEach((checkbox) => {
            // clear all checked checkboxes
            checkbox.checked = false;
          });
          // reset global upsell cart data object
          fmProductPageTool.globalUpsellCartDataObj = null;

          // added to unselect the accepted checkbox each time
          const acceptCheckboxes = document.querySelectorAll('#accept-testing-center, #accept-online, #aboveLms-online');
          acceptCheckboxes.forEach((checkbox) => {
            // clear all checked checkboxes
            checkbox.checked = false;
          });
        }
      },
      true
    );
  },

  /**
   * Initializes the accept terms checkboxes.
   * Handles the change event on the accept terms checkboxes and performs various actions such as hiding the cart summary,
   * enabling and disabling buttons, and unselecting upsells and proctor buttons.
   */
  initAcceptTermsCheckboxes: () => {
    const acceptCheckboxes = document.querySelectorAll('#accept-testing-center, #accept-online, #aboveLms-online');
    const summaryWrap = document.querySelector('#cart-summary-wrap');
    // clear all checked checkboxes on page load
    window.addEventListener('pageshow', () => {
      acceptCheckboxes.forEach((checkbox) => {
        // clear all checked checkboxes
        checkbox.checked = false;
        const acceptBtn = checkbox.closest('.form-check').nextElementSibling;
        acceptBtn.disabled = true; // disable all accept buttons
        // hide cart summary
        summaryWrap.classList.add('d-none');
      });
    });
    // disable all accept buttons until checkbox is checked
    acceptCheckboxes.forEach((checkbox) => {
      const acceptBtn = checkbox.closest('.form-check').nextElementSibling;
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          acceptBtn.disabled = false;
        } else {
          acceptBtn.disabled = true;
          summaryWrap.classList.add('d-none');

          // added to unselect the upsells in summary
          const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');
          upsellCheckboxes.forEach((checkbox) => {
            // clear all checked checkboxes
            checkbox.checked = false;
          });
        }
      });
    });
  },

  /**
   * Initializes the accept and continue buttons on the product page
   * and calls the getCardProductData function to render the cart summary.
   */
  initAcceptContinueBtns: () => {
    document.addEventListener(
      'click',
      (event) => {
        const eventElement = event.target;
        const acceptContinueBtn = eventElement.closest('.accept-continue-btn');
        if (acceptContinueBtn) {
          event.preventDefault();
          const productId = acceptContinueBtn.dataset.productId;
          const categoryProductId = acceptContinueBtn.dataset.categoryProductId;
          fmProductPageTool.getCardProductData(productId, categoryProductId);
          // Disable button so it can't be clicked multiple times and recall the cart summary
          acceptContinueBtn.disabled = true;
        }
      },
      true
    );
  },

  /**
   * Initializes the upsell checkboxes on the product page.
   * Handles the logic for updating the total price on the cart summary
   * and adding/removing upsell products to/from the cart.
   */
  initUpsellCheckboxes: () => {
    const upsellCheckboxes = document.querySelectorAll('.upsell-checkbox');

    // if user navigates back to the page, reset the total price and uncheck all upsell checkboxes
    window.addEventListener('pageshow', () => {
      const totalPriceEl = document.querySelector('.total-row .total-price');
      totalPriceEl.classList.add('shown');
      const mainProduct = document.querySelector('.main-product');
      let mainProductPrice = 0;
      const feePrice = Number(totalPriceEl.dataset.feePrice);
      if (mainProduct) {
        mainProductPrice = (Number(mainProduct.dataset.price) + feePrice).toFixed(2);
      } else {
        const unitPrice = Number(totalPriceEl.dataset.unitPrice);
        mainProductPrice = (unitPrice + feePrice).toFixed(2);
      }
      totalPriceEl.innerText = `$${mainProductPrice}`;
      fmProductPageTool.globalUpsellCartDataObj = null;
      upsellCheckboxes.forEach((checkbox) => {
        // clear all checked checkboxes
        checkbox.checked = false;
      });
    });

    // Cycles through checkboxes to update total and add to upsell cart
    upsellCheckboxes.forEach((checkbox) => {
      // add upsell prices to global object
      fmProductPageTool.upsellPrices[checkbox.value] = Number(checkbox.dataset.upsellPrice.replace(/\$|/g, ''));
      // add upsell cart data to global object
      checkbox.addEventListener('change', (e) => {
        const checkboxEl = e.target.closest('.upsell-checkbox');
        const upsellCartDataObject = JSON.parse(checkboxEl.dataset.cart);
        // remove first item in array
        upsellCartDataObject['cartProducts'].shift();
        // add upsell product to global cart
        if (checkboxEl.checked) {
          fmProductPageTool.addUpsellProductToCart(upsellCartDataObject);
        } else {
          // remove upsell product from global cart
          fmProductPageTool.removeUpsellProductFromCart(upsellCartDataObject);
        }
      });
    });
  },

  /**
   * Adds the upsell product to the global upsell cart data object.
   * @param {Object} upsellCartDataObject - The upsell product data object.
   */
  addUpsellProductToCart: (upsellCartDataObject) => {
    if (
      // if global upsell cart data object is null or empty, set it to the upsell cart data object
      fmProductPageTool.globalUpsellCartDataObj === null ||
      fmProductPageTool.globalUpsellCartDataObj['cartProducts'].length === 0
    ) {
      fmProductPageTool.globalUpsellCartDataObj = upsellCartDataObject;
    } else {
      // if global upsell cart data object already has products, check if the product already exists
      const productExists = fmProductPageTool.globalUpsellCartDataObj['cartProducts'].some(
        (product) => product.productId === upsellCartDataObject['cartProducts'][0].productId
      );
      if (!productExists) {
        // if product does not exist, add it to the global upsell cart data object
        fmProductPageTool.globalUpsellCartDataObj['cartProducts'].push(upsellCartDataObject['cartProducts'][0]);
      }
    }
    // get the ids of all products in the global upsell cart data object
    const idsIncart = fmProductPageTool.globalUpsellCartDataObj.cartProducts.map((item) => item.productId);
    // get the total price of all products in the global upsell cart data object
    const upsellTotal = idsIncart.reduce((acc, cur) => {
      const curPrice = fmProductPageTool.upsellPrices[cur];
      return acc + curPrice;
    }, 0);

    // use totalValue to update total display
    fmProductPageTool.updateTotalPrice(upsellTotal);
    // console.log('upsellTotal', upsellTotal);
  },

  /**
   * Removes the upsell product from the global upsell cart data object.
   * @param {Object} upsellCartDataObject - The upsell product data object.
   */
  removeUpsellProductFromCart: (upsellCartDataObject) => {
    const upsellsStillCheckedProductsArr = fmProductPageTool.globalUpsellCartDataObj['cartProducts'].filter(
      (product) => product.productId !== upsellCartDataObject['cartProducts'][0].productId
    );
    fmProductPageTool.globalUpsellCartDataObj['cartProducts'] = upsellsStillCheckedProductsArr;
    const idsIncart = fmProductPageTool.globalUpsellCartDataObj.cartProducts.map((item) => item.productId);
    const upsellTotal = idsIncart.reduce((acc, cur) => {
      const curPrice = fmProductPageTool.upsellPrices[cur];
      return acc + curPrice;
    }, 0);

    // use totalValue to update total display
    fmProductPageTool.updateTotalPrice(upsellTotal);
    // console.log('upsellTotal', upsellTotal);
  },

  /**
   * @param {String} upsellTotal - The total price for all upsell products in the cart.
   * Updates the total price on the cart summary.
   */
  updateTotalPrice: (upsellTotal) => {
    const mainProductTotal = fmProductPageTool.upsellPrices.mainProductTotal;
    const totalPriceNum = Number(mainProductTotal.replace(/\$|/g, '')) + upsellTotal;
    const totalRowEl = document.querySelector('.total-row');
    const totalPriceEl = totalRowEl.querySelector('.total-price');
    totalPriceEl.classList.add('shown');
    totalPriceEl.innerText = `$${totalPriceNum.toFixed(2)}`;
  },

  /**
   * @param {Number} productId - The main product id.
   * @param {Number} categoryProductId - The main product category id.
   * Gets the product data for the card wrap and renders the product and cart summary in the card wrap.
   */
  getCardProductData: (productId, categoryProductId) => {
    const url = `${fmProductPageTool.cartSummaryBaseUrl}productId=${productId}&categoryProductId=${categoryProductId}&proctorType=${fmProductPageTool.proctorType}&customPortalCategoryId=`;
    fetch(url, { credentials: 'include', mode: 'cors' })
      .then(checkFetchStatus)
      .then((res) => {
        if (res) {
          fmProductPageTool.renderProductCardAndOrderSummary(res.data);
          fmProductPageTool.upsellPrices.mainProductTotal = res.data.total;
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  },

  /**
   * @param {Object} cartSummaryData - The data from the cart summary API call.
   * Renders the product and cart summary in the card wrap.
   */
  renderProductCardAndOrderSummary: (cartSummaryData) => {
    const { total, product, productPrice, productPriceBeforeDiscount, proctorType, proctorPrice } = cartSummaryData;
    const { title, includes, specialInstructions, languages } = product;
    const totalRow = document.querySelector('.total-row');
    const totalPrice = totalRow.querySelector('.total-price');
    totalPrice.classList.add('shown');
    totalPrice.innerText = total;

    const productPriceEl = document.querySelector('.course-price');
    productPriceEl.classList.add('shown');
    if (productPriceBeforeDiscount == productPrice) {
      productPriceEl.textContent = `${productPrice}`;
    } else {
      productPriceEl.innerHTML = `<div><span class="crossed-out-price">${productPriceBeforeDiscount}</span></div> ${productPrice}`;
    }

    const productTitleEl = document.querySelector('.product-title');
    productTitleEl.textContent = title;
    const testCenterEl = document.querySelector('.test-center');
    let proctorTypeText = '';
    switch (proctorType) {
      case 'online':
        proctorTypeText = 'Remote Proctoring';
        testCenterEl.innerHTML = `<div class="col-8">${proctorTypeText}</div>
        <div class="col-4 text-end">${proctorPrice}</div>`;
        break;
      case 'testCenter':
        proctorTypeText = 'Testing Center';
        testCenterEl.innerHTML = `<div class="col-8">${proctorTypeText}</div>
        <div class="col-4 text-end">${proctorPrice}</div>`;
        break;
      case 'aboveLms':
        proctorTypeText = 'Employer or Health Department Proctored';
        testCenterEl.innerHTML = '';
        testCenterEl.classList.add('d-none');
        break;
      case 'null':
        proctorTypeText = '';
        break;
    }
    const productIncludes = includes ? `${includes}<br>` : '';

    const summaryWrap = document.querySelector('#cart-summary-wrap');
    // display cart summary
    summaryWrap.classList.remove('d-none');
    // Uncomment line below for looking at what is coming back from the API
    // console.log(cartSummaryData);
    if (testCenterEl) {
      summaryWrap.scrollIntoView({
        behavior: 'smooth',
      });
    }

    const languageList = languages.map((language) => language.name).join(', ');
    const productAvailableLanguages = `<p class="fw-700 mb-0">Available Languages</p>
    <p class="mb-0">You will be able to select your language in your account after purchase.</p>
    <p class="mb-0">${languageList}</p>`;

    const productSpecialInstructions = `<p class="text-theme-fh fw-700 mb-0">Special Instructions</p> ${specialInstructions}`;

    const proctorSelectionText = `
      <p class="fw-700 mb-0">Proctoring Selection</p>
      <p class="mb-0">${proctorTypeText}</p>`;

    const productData = document.querySelector('.product-data');
    if (proctorType == 'null' && (specialInstructions == '' || specialInstructions == null)) {
      // no proctor or special instructions
      const productDataText = `${productIncludes}${productAvailableLanguages}`;
      productData.innerHTML = productDataText;
    } else if (proctorType == 'null' && (specialInstructions != '' || specialInstructions != null)) {
      // no proctor but has special instructions
      const productDataText = `${productIncludes}${productAvailableLanguages}<br>${productSpecialInstructions}`;
      productData.innerHTML = productDataText;
    } else if (proctorType != 'null' && (specialInstructions == '' || specialInstructions == null)) {
      // has proctor but no special instructions
      const productDataText = `${productIncludes}${proctorSelectionText}<br>${productAvailableLanguages}`;
      productData.innerHTML = productDataText;
    } else {
      // both proctor and special instructions
      const productDataText = `${productIncludes}${proctorSelectionText}<br>${productAvailableLanguages}<br>${productSpecialInstructions}`;
      productData.innerHTML = productDataText;
    }
  },

  updateCartItemCount: (cart) => {
    const itemCount = cart.reduce((previousItem, currentItem) => previousItem + currentItem.quantity, 0);
    const viewCartLink = document.querySelectorAll('a.view-cart');
    for (let cartLink of viewCartLink) {
      const itemCountDisplay = cartLink.querySelector('.item-count');
      if (itemCount) {
        cartLink.classList.add('has-product');
        itemCountDisplay.dataset.qty = itemCount || 0;
      } else {
        cartLink.classList.remove('has-product');
        delete itemCountDisplay.dataset.qty;
      }
    }
  },

  /**
   * @param {Number} productId - The main product id.
   * @param {Number} categoryProductId - The main product category id.
   * @param {String} proctorType - The proctor type.
   * @param {Object} upsellData - The upsell data object.
   * Adds the main product and upsell product/s to the cart.
   */
  addMainProductAndUpsellToCart: (productId, categoryProductId, proctorType, upsellData) => {
    const url = `${fmProductPageTool.apiBaseUrl}/addCategoryProduct?productId=${productId}&proctorType=${proctorType}&categoryItemId=${categoryProductId}`;
    fetch(url, { credentials: 'include', mode: 'cors' })
      .then(checkFetchStatus)
      .then((data) => {
        // console.log('AddToCart Called');
        // console.log(data);
        if (data && data?.data?.totalCount > 0) {
          console.log('Products Added To Cart');
          // console.log(data.data.lineItems);
          fmProductPageTool.updateCartItemCount(data.data.lineItems);

          // redirecting user to the cart after adding the product/s
          // if no upsell data or upsellData is null, don't make another call to addCartProducts
          if (upsellData === null) {
            window.location.href = fmProductPageTool.cartUrl;
            return;
          }
          const upsellUrl = `${fmProductPageTool.apiBaseUrl}/addCartProducts?params=${upsellData}`;
          fetch(upsellUrl, { credentials: 'include', mode: 'cors' })
            .then(checkFetchStatus)
            .then((data) => {
              // console.log('AddToCart Called');
              // console.log(data);
              if (data && data?.data?.totalCount > 0) {
                // console.log('Products Added To Cart');
                // console.log(data.data.lineItems);
                fmProductPageTool.updateCartItemCount(data.data.lineItems);
                // redirecting user to the cart after adding the product/s
                window.location.href = fmProductPageTool.cartUrl;
              } else {
                console.log('There were no products added to cart');
              }
            })
            .catch(function (err) {
              console.error(err);
            });
        } else {
          console.log('There were no products added to cart');
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  },
};

fmProductPageTool.init();
